import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-trigger-event]';
export const PLUGIN_NAME = 'triggerEvent';


$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
    const element = this;
    System.import(/* webpackChunkName: "plugin--trigger-event" */ './plugin')
      .then(() => {
        $(element)[PLUGIN_NAME]();
      });
  });
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__trigger-event/index.js